import { ENTSWindow } from './ENTSWindow.js';

declare const window: ENTSWindow;

export const track = (data: unknown) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer.push(data);
};
